<template>
  <div>
    <div style="margin:10px 0px;" v-for="reply in replyList.filter(function(r) {return !r.parent})" >
      <div v-if="!reply.parent" class="row">
        <div @click="withdrawCheck(reply)">
          <img :src="!reply.memberProfileImage ? require('@/assets/img/profile_base.png') : reply.memberProfileImage &&
          reply.memberIsWithdraw ?  require('@/assets/img/profile_base.png') : reply.memberProfileImage" class="img-profile small rounded-circle" alt="">
        </div>
        <div class="col">
          <span :class="reply.memberIsWithdraw ? 'text-danger profile-text' : 'profile-text'">
            {{reply.memberIsWithdraw ? '탈퇴한 회원' : 'Lv.' + $root.$children[0].getLevelByMinute(reply.memberVolunteerMinute).level + reply.memberName}}
          </span>
          <vue-moments-ago prefix="약" suffix="전" :date="$root.$children[0].agoDateFormat(reply.createdDate)" lang="kr"></vue-moments-ago>
          <span class="manage-txt" v-if="$auth.user().id == reply.memberId" role="button" data-toggle="collapse"
                :href="'#replyEdit'+reply.id" >수정</span>
          <span href="#none;" class="manage-txt" v-if="$auth.user().id == reply.memberId" @click="deleteMsg(reply)">삭제</span>
          <div v-if="isRichContent " class="replyContents collapse show" v-html="reply.replyContents" :id="'replyEdit'+reply.id" style="transition: none;"></div>

          <div v-if="!isEditor" class="col input-group collapse" :id="'replyEdit'+ reply.id" style="transition: none;">
            <textarea placeholder="답변을 수정해주세요."  class="form-control custom-control" rows="3" style="resize:none" v-model="reply.replyContents"></textarea>
            <span class="input-group-addon btn btn-outline-danger" @click="modifyReply(reply)" data-toggle="collapse" :href="'#replyEdit'+reply.id">확인</span>
          </div>

          <div v-if="isEditor" class="col input-group collapse" :id="'replyEdit'+ reply.id" style="transition: none;">
            <div class="col">
              <quill-editor ref="activityDetails" v-model="reply.replyContents" rows="5"
                            :options="editorOption"
                            name="activityDetails">
              </quill-editor>
            </div>
            <span class="input-group-addon btn btn-outline-danger" @click="modifyReply(reply)" data-toggle="collapse" :href="'#replyEdit'+reply.id">확인</span>
          </div>
        </div>
        <a v-if="checkAnswerAuth()" @click="answer.parentId = reply.id; AnswerFocus(reply.id)" class="btn btn-sm btn-outline-primary" data-toggle="collapse" :href="'#collapseAnswer'+reply.id" role="button" aria-expanded="false">
          답글달기
        </a>
      </div>

      <div>
        <table>
          <tr v-if="replyAnswer.parent && reply.id == replyAnswer.parent.id" v-for="replyAnswer in replyList.slice().reverse()">
            <td @click="withdrawCheck(replyAnswer)" class="text-right">
              <img :src="!replyAnswer.memberProfileImage ? require('@/assets/img/profile_base.png') : replyAnswer.memberProfileImage &&
              replyAnswer.memberIsWithdraw ?  require('@/assets/img/profile_base.png') : replyAnswer.memberProfileImage" class="img-profile small rounded-circle" alt=""><br/>
            </td>
            <td class="col">
              <span class="profile-text">
                {{replyAnswer.memberIsWithdraw ? '탈퇴한 회원' : 'Lv.' + $root.$children[0].getLevelByMinute(replyAnswer.memberVolunteerMinute).level + replyAnswer.memberName}}
              </span>
              <vue-moments-ago prefix="약" suffix="전" :date="$root.$children[0].agoDateFormat(replyAnswer.createdDate)" lang="kr"></vue-moments-ago>
              <span class="manage-txt" v-if="$auth.user().id == replyAnswer.memberId" role="button"
                    :href="'#replyEdit'+replyAnswer.id" data-toggle="collapse">수정</span>
              <span class="manage-txt" v-if="$auth.user().id == replyAnswer.memberId" @click="deleteMsg(replyAnswer)">삭제</span>
              <br/>

              <div v-if="isRichContent " class="replyContents collapse show" v-html="replyAnswer.replyContents" :id="'replyEdit'+replyAnswer.id" style="transition: none;"></div>

              <div v-if="isEditor" class="col input-group collapse" :id="'replyEdit'+ replyAnswer.id" style="transition: none;">
                <div class="col">
                  <quill-editor ref="activityReview" v-model="replyAnswer.replyContents" rows="5"
                                :content="replyAnswer.replyContents"
                                :options="editorOption"
                                @change="onEditorChange($event)"
                                name="activityReview"
                                class="form-group quill-editor">
                  </quill-editor>
                </div>
                <span class="input-group-addon btn btn-outline-danger" @click="modifyReply(replyAnswer)" data-toggle="collapse" :href="'#replyEdit'+replyAnswer.id">확인</span>
              </div>

              <div v-if="!$props.isEditor" class="col input-group collapse" :id="'replyEdit'+replyAnswer.id" style="transition: none">
                <textarea placeholder="답변을 수정 해주세요." class="form-control custom-control" rows="3" style="resize:none" v-model="replyAnswer.replyContents"></textarea>
                <span class="input-group-addon btn btn-outline-danger" @click="modifyReply(replyAnswer)" data-toggle="collapse" :href="'#replyEdit'+replyAnswer.id">확인</span>
              </div>
              <br>

            </td>
          </tr>
        </table>
        <div class="row answerArea" :id="'collapseAnswer'+reply.id" v-if="checkAnswerAuth() && answer.parentId == reply.id">
          <div class="col input-group">
            <textarea placeholder="답변을 남겨주세요." class="form-control custom-control" rows="3" :ref="'collapseAnswer'+reply.id" style="resize:none" v-model="answer.replyContents"></textarea>
            <span class="input-group-addon btn btn-outline-danger" @click="answerReply(reply)">작성</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import VueMomentsAgo from 'vue-moments-ago'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import {quillEditor} from 'vue-quill-editor'

  import Quill from 'quill';

  import imageUpload from 'quill-plugin-image-upload';
  import ImageResize from 'quill-image-resize-module';

  Quill.register('modules/imageUpload', imageUpload)
  Quill.register('modules/imageResize', ImageResize)

  export default {
    name: 'ActivityReplyAnswer',
    components: {
      VueMomentsAgo, quillEditor
    },

    data() {
            return {
              answer : {
                replyContents:'',
                parentId: 0,
                memberId: 0,
                activityId: 0,
                MemberIsWithdraw: false,
              },
              page:{
                pageNum:0,
                pageSize:5,
              },
              editorOption: {
                placeholder: '소중한 리뷰를 남겨주세요.',
                modules: {
                  toolbar: [
                    [{'size': ['small', false, 'large']}],
                    ['bold', 'italic'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    ['link', 'image', 'video'],
                    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }]
                  ],
                  history: {
                    delay: 1000,
                    maxStack: 50,
                    userOnly: false
                  },
                  imageUpload: {
                    upload: file => {
                      // return a Promise that resolves in a link to the uploaded image
                      return new Promise((resolve, reject) => {
                        this.makeUploadFiles([file], function(res){
                          resolve(res);
                        })
                      });
                    }
                  },
                  imageResize: {
                    modules: ["Resize", "DisplaySize", "Toolbar"]
                  }
                },

                placeholder: '이곳에 입력해 주세요.',
              },
            };
        },
      props: ['replyList', 'reply','isRichContent', 'replyType', 'answerAuth', 'isEditor'],
        methods: {
          answerReply: function(reply) {
            if(this.answer.parentId != reply.id)
              this.answer.parentId = reply.id;
            else {
              this.answer.memberId = this.$auth.user().id;
              this.answer.replyType = reply.replyType;
              this.answer.activityId = reply.activityId;

              let me = this
              this.axios.post(process.env.VUE_APP_ACTIVITY_API_URL + '/reply', this.answer)
                      .then(function (res) {
                        me.$root.$children[0].commonDialog('대댓글등록', '답변이 등록 되었습니다.');
                        me.answer.replyContents = "";
                        me.answer.parentId = 0;
                        me.$parent.getList();
                      }).catch(function (error) {
                console.log(error);
              });
            }
          },
          getList() {
            let me = this;
            this.axios.get(process.env.VUE_APP_ACTIVITY_API_URL +
                    `/reply/list?activityId=${this.reply.activityId}&replyType=${this.reply.replyType}&page=${this.page.pageNum}&size=${this.page.pageSize}`)
                    .then(function (res) {
                      console.log(res)
                      me.replyList = res.data;
                    }).catch(function (error) {
              console.log(error);
            });
          },
          getMore() {
            this.page.pageSize+=10;
            this.getList();
          },
          checkAnswerAuth() {
            return this.$auth.check() && this.$auth.user().roleNames.includes(this.$props.answerAuth);
          },
          withdrawCheck(reply){
            if (reply.memberIsWithdraw){
              if (this.$auth.user().roleNames.includes('ADMIN'))
                this.$root.$children[0].getMemberInfo(reply.memberId)
              else
                this.$root.$children[0].commonDialog('탈퇴한 회원입니다.')
            }else{
              this.$root.$children[0].getMemberInfo(reply.memberId)
            }
          },
          modifyReply(reply) {
            let me = this;
            this.axios.put(process.env.VUE_APP_REPLY_API_URL, reply)
                    .then(function (res) {
                      me.$root.$children[0].commonDialog('댓글 수정','수정이 완료 되었습니다.');
                      me.$parent.getList();
                    }).catch(function (error) {
              console.log(error);
            });
          },
          deleteReply(reply) {
            let me = this;
            this.axios.delete(`${process.env.VUE_APP_REPLY_API_URL}/${reply.id}`)
                    .then(function (res) {
                      console.log(res.data)
                      me.$parent.getList();
                      me.$root.$children[0].commonDialog('댓글이 삭제 되었습니다.')
                    }).catch(function (error) {
              console.log(error);
            });
          },
          deleteMsg(reply){
            this.$modal.show('dialog', {
              text: `댓글을 삭제하시겠습니까?`,
              buttons: [
                {
                  title: '삭제',
                  handler: () => {
                    this.deleteReply(reply);
                    this.$modal.hide('dialog');
                  }
                },
                {
                  title: '취소'
                },
              ]
            })
          },
          AnswerFocus(replyid){
            //let collapseanswer = 'collapseAnswer'+replyid;

            //console.log(collapseanswer);
            //this.$refs.collapseanswer.focus();
            /*this.$nextTick(() => {
              this.$refs.collapseAnswer[replyid].focus();
            })*/
            //this.$refs['collapseAnswer'+replyid].focus()
          },
          onEditorChange({quill, html, text}) {
            this.reply.replyContents = html
          },
          async makeUploadFiles(files, callback) {
            let formData = new FormData();
            for (let i = 0; i < files.length; ++i) {
              formData.append('sourceFile', files[i]);
            }
            this.$root.$children[0].uploadFile(formData, 'REVIEW').then(callback);

          },

        },
        mounted() {
        }
    }
</script>
<style>
  .answerArea{margin-top:10px;}
</style>
